import { status, token } from '@thiememeulenhoff/lit-sdk';
import { ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const SCORE_LEVEL_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('albert-score-label-error-background-default'),
  [ScoreLevel.Unsatisfactory]: token(
    'albert-score-label-warning-background-default',
  ),
  [ScoreLevel.Marginal]: token('albert-score-label-warning-background-default'),
  [ScoreLevel.Satisfactory]: token(
    'albert-score-label-success-background-default',
  ),
  [ScoreLevel.Excellent]: token(
    'albert-score-label-success-background-default',
  ),
};

export const SCORE_LEVEL_COLOR_HOVER_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('albert-score-label-error-background-hover'),
  [ScoreLevel.Unsatisfactory]: token(
    'albert-score-label-warning-background-hover',
  ),
  [ScoreLevel.Marginal]: token('albert-score-label-warning-background-hover'),
  [ScoreLevel.Satisfactory]: token(
    'albert-score-label-success-background-hover',
  ),
  [ScoreLevel.Excellent]: token('albert-score-label-success-background-hover'),
};

export const SCORE_LEVEL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('foreground-inverse'),
  [ScoreLevel.Unsatisfactory]: token('foreground-inverse'),
  [ScoreLevel.Marginal]: token('foreground-inverse'),
  [ScoreLevel.Satisfactory]: token('foreground-inverse'),
  [ScoreLevel.Excellent]: token('foreground-inverse'),
};

export const SCORE_LEVEL_NEUTRAL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> =
  {
    [ScoreLevel.Poor]: status('danger', 'foreground'),
    [ScoreLevel.Unsatisfactory]: status('warning', 'foreground'),
    [ScoreLevel.Marginal]: status('warning', 'foreground'),
    [ScoreLevel.Satisfactory]: status('success', 'foreground'),
    [ScoreLevel.Excellent]: status('success', 'foreground'),
  };

export const SCORE_LEVEL_ICON_MAP: Record<ScoreLevel, string> = {
  [ScoreLevel.Poor]: 'close',
  [ScoreLevel.Unsatisfactory]: 'wave-triangle',
  [ScoreLevel.Marginal]: 'wave-triangle',
  [ScoreLevel.Satisfactory]: 'check',
  [ScoreLevel.Excellent]: 'check',
};

export const SCORE_LEVEL_BORDER_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: status('danger', 'border'),
  [ScoreLevel.Unsatisfactory]: status('warning', 'border'),
  [ScoreLevel.Marginal]: status('warning', 'border'),
  [ScoreLevel.Satisfactory]: status('success', 'border'),
  [ScoreLevel.Excellent]: status('success', 'border'),
};
